import { DeviceType } from '@/graphql/generated/schemas'

import { ConnectionI, RectI } from '../../types/types'

export const getPopOverTitle = (connection: ConnectionI) => {
  if (connection?.isTailgateEnabled) {
    return 'Associated, Tailgating Enabled:'
  }
  if (connection?.isTailgateGridConfigured) {
    return 'Associated, Tailgating Grid Configured:'
  }
  if (connection?.deviceType == DeviceType.Alarm && connection?.isConnected) {
    return 'Associated'
  }
  if (connection?.isConnected) {
    return 'Associated, \n Awaiting Tailgating Grid Configuration:'
  }
  return 'Ready to Associate:'
}

export const isPopupOpen = (rect: RectI) => {
  if (rect.x > 0 && rect.y > 0 && rect.width > 0 && rect.height > 0) {
    return true
  }
  return false
}
